import { Component, computed, inject } from '@angular/core';
import { AuthService } from '../../../pages/auth/auth.service';
import { CommonModule } from '@angular/common';
import { GeneralIconButtonComponent } from '../general-icon-button/general-icon-button.component';
import { MatIconModule } from '@angular/material/icon';
import { TooltipPosition } from '../../../../core/directives/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { UserPhotoInitialsComponent } from '../user-photo-initials/user-photo-initials.component';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [CommonModule, MatIconModule, UserPhotoInitialsComponent, TranslateModule, GeneralIconButtonComponent],
  templateUrl: './toolbar.html',
  styleUrls: ['./toolbar.scss'],
})
export class Toolbar {
  protected readonly TooltipPosition = TooltipPosition;
  protected auth: AuthService = inject(AuthService);
  protected userName = computed(() => {
    const user = this.auth.user();
    return user?.username || user?.firstName + ' ' + user?.lastName || '';
  });

  goHome(): void {
    // navigate to main page
  }

  login() {
    this.auth.login();
  }

  logout() {
    this.auth.logout();
  }
}
